import { ILight } from '../Light/types';
import { OperationState } from "../OperationState";

export interface ILightVar extends ILight  {
    setPercent: number;
    percent: number;
}

export const schema = 'AutomationApps.Devices.Lights.LightVar';